exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.kye-canvas-table-header-popper-wrap {\n  position: absolute;\n}\n.kye-canvas-table-header-popper .kye-plugin-popper-wrap-content {\n  max-height: none;\n}\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/public/components/kye-canvas-table/header-tip.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB;AACD;EACE,iBAAiB;CAClB","file":"header-tip.vue","sourcesContent":["\n.kye-canvas-table-header-popper-wrap {\n  position: absolute;\n}\n.kye-canvas-table-header-popper .kye-plugin-popper-wrap-content {\n  max-height: none;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74251806","scoped":false,"hasInlineConfig":false}!./node_modules/fast-sass-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/public/components/kye-canvas-table/header-tip.vue
// module id = /C1l
// module chunks = 7